import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { OWNER } from "@/lib/legalContent";

export default function PoliticaPrivacidad() {
  return (
    <LegalLayout
      title="Política de Privacidad"
      intro="Información sobre el tratamiento de tus datos personales conforme al Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018 (LOPDGDD)."
    >
      <LegalSection heading="1. Responsable del tratamiento">
        <p>
          De conformidad con el Reglamento General de Protección de Datos 2016/679 (RGPD) y la Ley Orgánica 3/2018, de 5
          de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), te informamos
          de que el responsable del tratamiento de tus datos es:
        </p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li><strong>Titular:</strong> {OWNER.name}</li>
          <li><strong>NIF:</strong> {OWNER.nif}</li>
          <li><strong>Domicilio:</strong> {OWNER.address}</li>
          <li><strong>Correo electrónico:</strong> <a className="text-primary underline underline-offset-2" href={`mailto:${OWNER.email}`}>{OWNER.email}</a></li>
          <li><strong>Teléfono:</strong> {OWNER.phoneLegal}</li>
        </ul>
      </LegalSection>

      <LegalSection heading="2. ¿Qué datos recogemos y cómo?">
        <p>
          Únicamente tratamos los datos personales que nos facilitas voluntariamente a través de los medios de contacto
          disponibles en esta web. En concreto, mediante el <strong>formulario de solicitud de cita</strong> podemos
          recoger:
        </p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Nombre completo.</li>
          <li>Número de teléfono.</li>
          <li>El servicio que te interesa (opcional).</li>
          <li>El mensaje o consulta que decidas incluir.</li>
        </ul>
        <p>
          Este formulario prepara un mensaje para que contactes con la clínica a través de WhatsApp o teléfono. También
          tratamos los datos que nos facilites si te comunicas con nosotros directamente por teléfono, WhatsApp o correo
          electrónico. Todos los campos señalados como obligatorios deberán cumplimentarse, ya que su omisión puede
          impedir que podamos atender tu solicitud.
        </p>
      </LegalSection>

      <LegalSection heading="3. Finalidad del tratamiento">
        <p>En {OWNER.name} trataremos tus datos personales con las siguientes finalidades:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Atender y gestionar las solicitudes de cita, consultas e información que nos remitas.</li>
          <li>Ponernos en contacto contigo para responder a tu solicitud y prestarte los servicios de podología requeridos.</li>
          <li>Mantener la comunicación necesaria durante la relación asistencial que se derive.</li>
        </ul>
        <p className="rounded-xl border border-border bg-secondary/40 p-4 text-sm">
          Esta web <strong>no</strong> dispone de newsletter ni envía comunicaciones comerciales por correo electrónico,
          <strong> no</strong> gestiona procesos de selección de personal ni recogida de currículums, y <strong>no</strong>
          {" "}elabora perfiles comerciales. Por tanto, no realizamos ese tipo de tratamientos.
        </p>
      </LegalSection>

      <LegalSection heading="4. Legitimación (base jurídica)">
        <p>El tratamiento de tus datos se basa en:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>
            <strong>Tu consentimiento libre, específico, informado e inequívoco</strong> (art. 6.1.a RGPD), que
            manifiestas al enviar el formulario aceptando esta Política de Privacidad, o al contactar con nosotros por
            los medios indicados.
          </li>
          <li>
            La <strong>aplicación de medidas precontractuales</strong> y la ejecución de la relación asistencial
            solicitada (art. 6.1.b RGPD).
          </li>
        </ul>
        <p>
          Si no nos facilitas tus datos, o los facilitas de forma errónea o incompleta, no podremos atender tu solicitud.
        </p>
      </LegalSection>

      <LegalSection heading="5. Conservación de los datos">
        <p>
          Los datos personales proporcionados se conservarán mientras se gestiona tu comunicación y mientras no
          solicites su supresión, y durante el tiempo mínimo necesario para cumplir con las obligaciones legales
          aplicables o para atender posibles responsabilidades derivadas de los servicios prestados.
        </p>
      </LegalSection>

      <LegalSection heading="6. Destinatarios">
        <p>
          Tus datos serán conservados bajo estrictas medidas de seguridad que garanticen su confidencialidad. No se
          comunicarán datos a terceros, salvo obligación legal o cuando resulte necesario para la correcta prestación del
          servicio a través de proveedores que actúan como encargados del tratamiento y con los que se suscribe el
          correspondiente contrato conforme a la normativa vigente.
        </p>
        <p>
          <strong>Transferencias internacionales:</strong> {OWNER.name} no cede datos personales a terceros ni contrata
          con proveedores prestadores de servicios fuera de la Unión Europea con esa finalidad.
        </p>
      </LegalSection>

      <LegalSection heading="7. Derechos de los usuarios">
        <p>Como interesado, tienes derecho a:</p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Acceder a tus datos personales.</li>
          <li>Solicitar la rectificación de los datos inexactos.</li>
          <li>Solicitar su supresión cuando, entre otros motivos, ya no sean necesarios para los fines para los que fueron recogidos.</li>
          <li>Solicitar la limitación del tratamiento en determinadas circunstancias.</li>
          <li>Oponerte al tratamiento de tus datos por motivos relacionados con tu situación particular.</li>
          <li>Solicitar la portabilidad de tus datos.</li>
          <li>Retirar el consentimiento prestado en cualquier momento.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="8. ¿Cómo ejercer tus derechos?">
        <p>
          Podrás ejercer estos derechos aportando copia de un documento identificativo y exponiendo brevemente tu
          solicitud, mediante carta dirigida a {OWNER.name}, {OWNER.address}, o a través del correo electrónico{" "}
          <a className="text-primary underline underline-offset-2" href={`mailto:${OWNER.email}`}>{OWNER.email}</a>.
        </p>
      </LegalSection>

      <LegalSection heading="9. Reclamación ante la autoridad de control">
        <p>
          En caso de que consideres vulnerado alguno de tus derechos, tienes derecho a presentar una reclamación ante la
          Agencia Española de Protección de Datos (AEPD), C/ Jorge Juan, 6, 28001 Madrid, o a través de su sede
          electrónica:{" "}
          <a className="text-primary underline underline-offset-2" href="https://sedeagpd.gob.es/sede-electronica-web/" target="_blank" rel="noopener noreferrer">
            https://sedeagpd.gob.es/sede-electronica-web/
          </a>.
        </p>
      </LegalSection>

      <LegalSection heading="10. Garantía de veracidad">
        <p>
          El Usuario garantiza que los datos aportados son verdaderos, exactos, completos y actualizados, siendo
          responsable de cualquier daño o perjuicio, directo o indirecto, que pudiera ocasionarse como consecuencia del
          incumplimiento de tal obligación.
        </p>
      </LegalSection>

      <LegalSection heading="11. Modificación de la Política de Privacidad">
        <p>
          {OWNER.name} se reserva el derecho a modificar, total o parcialmente, la presente Política de Privacidad,
          publicando los cambios en el Sitio Web. Se recomienda revisarla periódicamente.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
